export const WORKSPACE_FILTERS = 'WORKSPACE_FILTERS';
export const FILTER_CATEGORIES = 'FILTER_CATEGORIES';
export const FILTERED_FULFILLERS = 'FILTERED_FULFILLERS';
export const GEOCODE_SELECTED_FILTERS = 'GEOCODE_SELECTED_FILTERS';
